import mem from 'mem';
import { Auth } from '../../common/auth';
import { axiosPublic } from './axiosPublic';

const refreshTokenAsync = async () => {
    const refreshToken = Auth.getRefreshToken();

    try {
        const response = await axiosPublic.post('/auth/renew', { refreshToken });
        const { success, data } = response.data;

        if (success) {
            Auth.setRefreshToken(data.refreshToken);
            Auth.setAccessToken(data.accessToken);
            Auth.setUser(data.user);
        } else {
            Auth.clear();
        }

        return { success, data };
    } catch (error) {
        Auth.clear();
        return { success: false, data: null };
    }
};

export const memoizedRefreshToken = mem(refreshTokenAsync, { maxAge: 10000 });
